import { validate } from '@nx/stdlib';
import { Type } from '@sinclair/typebox';

export type GuideStatus = {
  id: string;
  name: string;
  currentPage: number;
  isCompleted: boolean;
  createdAt: string;
  updatedAt: string;
};

export type GuideStatusesListResponse = {
  items: GuideStatus[];
};

export type GuideStatusCreateInput = Pick<GuideStatus, 'name' | 'currentPage' | 'isCompleted'>;

export type GuideStatusUpdateInput = Partial<GuideStatusCreateInput>;

const guideStatusSchema = Type.Object({
  id: Type.String(),
  name: Type.String(),
  currentPage: Type.Number(),
  isCompleted: Type.Boolean(),
  createdAt: Type.String(),
  updatedAt: Type.String(),
});

const listSchema = Type.Object({
  items: Type.Array(guideStatusSchema),
});

export const validateGuideStatusResponse = (response: GuideStatus) => {
  return validate(guideStatusSchema, response);
};

export const validateListResponse = (response: GuideStatusesListResponse) => {
  return validate(listSchema, response);
};
